import axios from '@/utils/http';
// import qs from 'qs';

const about = {

    addVisitor(param) {
        return axios.post('/visitor/add', param)
    }

}

export default about;